export const routes = {
    index: '/',
    generateAndFetch: '/report',
    generate: '/report/async',
    pollResult: '/report/poll',
};
